import { useTheme } from '@mui/material';

import { BaseMessage } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/BaseMessage';
import { BaseText } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/BaseText';
import { MARGIN_SPACING_WITHOUT_AVATAR } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/constants';

import { useAvatarContent } from './hooks';

import type { Message } from 'applications/GSP/pages/ParentHelper/types';
import type { FC } from 'react';

type QuestionProps = Pick<Message, 'withoutAvatar' | 'question'>;

export const Question: FC<QuestionProps> = ({ question, withoutAvatar }) => {
  const avatarContent = useAvatarContent();
  const theme = useTheme();

  if (!question) return null;

  return (
    <BaseMessage
      avatarContent={!withoutAvatar && avatarContent}
      sx={{
        flexDirection: 'row-reverse',
        marginLeft: 'auto',
        marginRight: {
          md: withoutAvatar ? theme.spacing(MARGIN_SPACING_WITHOUT_AVATAR) : 0,
        },
      }}
    >
      <BaseText sx={{ borderRadius: '16px 16px 0px 16px' }}>
        {question}
      </BaseText>
    </BaseMessage>
  );
};
